import { render, staticRenderFns } from "./poc-network-description.vue?vue&type=template&id=852954f8&"
import script from "./poc-network-description.vue?vue&type=script&lang=js&"
export * from "./poc-network-description.vue?vue&type=script&lang=js&"
import style0 from "./poc-network-description.vue?vue&type=style&index=0&id=852954f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports